import React, { useRef } from 'react';
var VeltSidebarButtonCommentsCount = function (props) {
    var defaultCondition = props.defaultCondition, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-sidebar-button-comments-count", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined }, children));
};
export default VeltSidebarButtonCommentsCount;
